import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type { WalletLedgerListQuery, WalletLedgerRecord } from '@/types/wallet-ledger';

export const walletLedgerApi = {
  list(query: WalletLedgerListQuery = {}) {
    return request<PaginatedResult<WalletLedgerRecord>>({
      url: '/wallet-ledger',
      method: 'GET',
      params: query,
    });
  },
};
